export default [
  {
    id: 2,
    amount: 1090000,
    reference: "415123b0-3e51-4c22-9faf-256630bc2x83",
    paid_at: "1400/04/22 10:41:05",
    send_invoice: false,
  },
  {
    id: 1,
    amount: 545000,
    reference: "d1412540-3b61-4c22-94ab-216130ec2e83",
    paid_at: "1400/03/20 10:42:40",
    send_invoice: true,
  },
];
